module.exports = __webpack_public_path__ + "img/modelo2.335f99cd.jpg";